import NextLink from 'next/link'
import { Link, Box, Text, Flex, Stack, HStack, Divider, Spacer, VStack, Badge, Wrap, WrapItem, Heading, LinkBox, LinkOverlay, useColorModeValue } from '@chakra-ui/react'

export default function PhenotypeCard(props) {
    const bg = useColorModeValue("white", "")
    const color = useColorModeValue("black", "neutral.200")
    const borderColor = useColorModeValue("gray.100", "neutral.900")
    // console.log(props.phenotype);
    return (
    
        <LinkBox as="article" w="100%" p={3} bg={bg} color={color} borderRadius={15} border="1px" borderColor={borderColor} overflow='hidden'>

        <Flex>
        <Box w="100%">
             <NextLink href={`/phenotypes/${props.phenotype.slug}`} passHref>
                 <LinkOverlay>
            <Heading as="h2" fontSize={16} maxW={["430", "600", "450", "500", "600"]} isTruncated>{props.phenotype.name}</Heading>
            </LinkOverlay>
            </NextLink>
        </Box>
        <Spacer />
        <Box align="right">
        {/* <Text color="gray.400" fontSize={11} fontWeight="bold">
        {props.variant.variant_type.toUpperCase()}
        </Text> */}
        {/* <Box>{props.phenotype.inheritance.map(inheritance => <Text fontSize={11} mt={0} fontWeight='bold' color="#849294" textTransform="uppercase">{inheritance}</Text>)}</Box> */}
        </Box>
        {/* <VStack> */}
        <Box>
            {/* <Text fontSize={11} mt={2} fontWeight='bold' color="#849294" textTransform="uppercase">Inheritance</Text> */}
        </Box>
        </Flex>
        {/* <Box>{props.phenotype.inheritance.map(inheritance => <Text fontSize={11} mt={0} fontWeight='bold' color="#849294" textTransform="uppercase">{inheritance}</Text>)}</Box> */}
        {/* </VStack> */}

        <Box>
        <Divider orientation="horizontal" mt={5} colorScheme="red" borderColor={borderColor}/>

        <Box mt={2}>
            <Heading as="h6" size="xs" color="#849294" fontWeight="bold" fontSize="12px">GENES</Heading>
        </Box>
        {props.phenotype.genes.length == 0 ?
        <Text fontSize={11} mt={1} fontWeight='bold' color="#849294" >NOT AVAILABLE</Text>
        : null}
        
        {props.phenotype.genes.length > 3 ?
        <Wrap mt={2}>
        {props.phenotype.genes.slice(0,3).map((gene, index) => 
        <WrapItem key={index}>
              <Badge ml="0" colorScheme="gray" borderRadius="12" px={3} py={1} textTransform="capitalize">
              {gene.symbol}
            </Badge>
            </WrapItem>
        )}
        
        <Heading size={"xs"} fontSize={"12"} ml="0" colorScheme="grsay" borderRadius="lg" pl={3} pr={3} pt={0.5} textTransform="capitalize">+{props.phenotype.genes.length - 3} MORE</Heading>
        </Wrap>
        : 
        <Wrap mt={2}>
        {props.phenotype.genes.map((gene, index) => 
        <WrapItem key={index}>
              <Badge ml="0" colorScheme="gray" borderRadius="12" px={3} py={1} textTransform="capitalize">
              {gene.symbol}
            </Badge>
            </WrapItem>
        )}
        </Wrap>
        }
        </Box>

        </LinkBox>
        
    )
}